<template>
  <div class="header">
    <div class="field-narrow">{{ $t('number') }}</div>
    <div class="field-medium">{{ $t('project') }}</div>
    <div class="field-medium">{{ $t('name') }}</div>
    <div class="field-medium">{{ $t('type') }}</div>
    <div class="field-medium">{{ $t('message') }}</div>
    <div class="field-medium">{{ $t('createTime') }}</div>
  </div>
</template>

<script>
export default {
};
</script>

<style>
.header {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding: 10px;
}

.field-narrow {
  flex: 1;
  text-align: center;
}

.field-medium {
  flex: 2;
  text-align: center;
}

.err-msg {
  width: 100vw;
  color: red;
  text-align: center;
}
</style>
